// Set Eloqua Form Data
var timerId = null, timeout = 5;
function WaitUntilCustomerGUIDIsRetrieved() {
	if (!!(timerId)) {
	    if (timeout == 0) {
			return;
		}
		if (typeof this.GetElqCustomerGUID === 'function') {
			var elqCustomerGUID = GetElqCustomerGUID();
			var input_2_3 = document.querySelector('#input_2_3');
			input_2_3.value = elqCustomerGUID;

			var input_1_11 = document.querySelector('#input_1_11');
			if ( input_1_11 ) {
				input_1_11.value = elqCustomerGUID;
			}
			return;
		}
		timeout -= 1;
	}
	timerId = setTimeout("WaitUntilCustomerGUIDIsRetrieved()", 500);
	return;
}
_elqQ.push(['elqGetCustomerGUID']);

document.addEventListener("DOMContentLoaded", function() {

	// Set Eloqua Form Data
	// WaitUntilCustomerGUIDIsRetrieved();
});

jQuery(function($) {

	const root = document.documentElement;
	const stickyHeader = document.querySelector('#sticky-header');

	function setStickyHeaderHeight() {
		if ( Foundation.MediaQuery.atLeast('large') ) {
			root.style.setProperty('--sticky-header-height', stickyHeader.offsetHeight + "px");
		} else {
			root.style.setProperty('--sticky-header-height', '0px');
		}
	}

	var $interstitialModal = new Foundation.Reveal($('#interstitial-modal'));
	$('a[target="_blank"]:not(.offsite-uri)').click(function(e) {
	  e.preventDefault();
	  var redirect = $(this)[0].href;
	  var matches = redirect.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
	  var domain = matches && matches[1];  // domain will be null if no match is found
	  $('#interstitial-modal .offsite-uri-text').html(redirect);
	  $('#interstitial-modal .offsite-uri').attr('href', redirect);
	  $interstitialModal.open();
	  // countDownExit(redirect);
	});
	$('a.offsite-uri').click(function(e) {
	  $interstitialModal.close();
	});

	$(document).ready(function() {

		setStickyHeaderHeight();

		window.addEventListener('resize', setStickyHeaderHeight);

	});

}); 